export enum ExperimentEvent {
  EXPERIMENT_APPLIED = 'experimentApplied',
}
